import { render, staticRenderFns } from "./SoaSection.vue?vue&type=template&id=2dea00b3&lang=pug"
import script from "./SoaSection.vue?vue&type=script&lang=js"
export * from "./SoaSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports